import { render, staticRenderFns } from "./apply-info.vue?vue&type=template&id=bb70e934&scoped=true"
import script from "./apply-info.vue?vue&type=script&lang=js"
export * from "./apply-info.vue?vue&type=script&lang=js"
import style0 from "./apply-info.vue?vue&type=style&index=0&id=bb70e934&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb70e934",
  null
  
)

export default component.exports